module.exports = __webpack_public_path__ + "static/media/Illus-BowlEmpty-Small.364f4f85.png";